type ErrorBody = {
	errors: [
		{
			domain: string;
			reason: string;
			message: string;
		},
	];
	code: number;
	message: string;
};

export const getErrorBody = (e: any): Promise<ErrorBody> => {
	return e.response?.json();
};
